module.exports = __webpack_public_path__ + "static/media/ic_ledger_report.c8040287.png";